import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UpdateAsEnterpriseReviewComponent } from './update-as-enterprise-review-enterprise/update-as-enterprise.component';


const routes: Routes = [
  {
    path: 'kyc-confirm-account-review/update-enterprise-review-enterprise',
    component: UpdateAsEnterpriseReviewComponent,
    // canActivate: [
    //   AuthGuard,
    //   CanActivateChildGuard
    // ],
    // canDeactivate: [ConfirmDeactivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KycConfirmAccountRoutingModule { }
